// 由 webpack DefinePlugin 注入：生产见 config/prod.env.js；开发在 config/dev.env.js 中覆盖为空串
// 生产：直连 https://admin.kingcer.com；本地 dev：空串 + config/index.js 中 proxyTable 转发到接口域
export const API_BASE = process.env.API_BASE || ''



// WEBPACK FOOTER //
// ./src/config/apiBase.js